import { forwardRef } from 'react';
import { cn } from '../../utils/cn';

// Textarea — área de texto con los tokens del design system (mismo aspecto que el editor de
// respuestas rápidas de la Mesa de ayuda). Reenvía el ref: los editores que insertan texto
// en la posición del cursor necesitan leer `selectionStart`/`selectionEnd`.
//
// Props (además de las nativas):
//   - invalid?: boolean    (borde rojo)
//   - className?: string

export const Textarea = forwardRef(function Textarea({ invalid, className, rows = 6, ...rest }, ref) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      className={cn(
        'w-full rounded-lg border bg-bg px-3 py-2 text-sm text-fg resize-y',
        'placeholder:text-fg-subtle',
        'focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        invalid ? 'border-status-error' : 'border-border',
        className,
      )}
      {...rest}
    />
  );
});

Textarea.displayName = 'Textarea';

export default Textarea;
